import { Table, TableBody, TableHead } from '@mui/material'

import CustomTableRow from 'ui/table/CustomTableRow'
import { TableHeader } from './components'

import { Milkings } from 'models/IFarm'
import { useGetCellOptions } from './components/hooks/useGetCellOptions'

interface MilkYieldLinearWidgetProps {
	milkings: Milkings[]
	total_reject_milk_sum: number
	total_sell_milk_sum: number
}
export const MilkYieldLinearWidget = ({
	milkings,
	total_reject_milk_sum,
	total_sell_milk_sum,
}: MilkYieldLinearWidgetProps) => {
	const TABLE_OPTIONS = useGetCellOptions({
		milkings,
		total_reject_milk_sum,
		total_sell_milk_sum,
	})
	return (
		<Table>
			<TableHead>
				<TableHeader />
			</TableHead>
			<TableBody>
				{TABLE_OPTIONS.map((option, index) => (
					<CustomTableRow
						key={index}
						rowKey={option.rowKey}
						cellItems={option.cellItems}
						rowHeight={option.rowHeight}
					/>
				))}
			</TableBody>
		</Table>
	)
}
